import { render, staticRenderFns } from "./fooret.vue?vue&type=template&id=7d45ae3c&scoped=true"
import script from "./fooret.vue?vue&type=script&lang=js"
export * from "./fooret.vue?vue&type=script&lang=js"
import style0 from "./fooret.vue?vue&type=style&index=0&id=7d45ae3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45ae3c",
  null
  
)

export default component.exports